"use client";

import { format } from "date-fns";
import { Doc } from "@convex/_generated/dataModel";

interface EmailMessageProps {
  email: Doc<"receivedEmails"> | Doc<"sentEmails">;
  type: "received" | "sent";
}

export function EmailMessage({ email, type }: EmailMessageProps) {
  const isReceived = type === "received";
  const receivedEmail = email as Doc<"receivedEmails">;
  const sentEmail = email as Doc<"sentEmails">;

  return (
    <div className={`p-4 rounded-lg overflow-hidden ${isReceived ? "bg-muted" : "bg-primary/10"}`}>
      <div className="flex items-center justify-between mb-2">
        <div>
          <p className="text-sm font-medium">
            {isReceived
              ? receivedEmail.fromName || receivedEmail.fromEmail
              : `To: ${sentEmail.recipientName || sentEmail.recipient}`}
          </p>
          {isReceived && receivedEmail.fromName && (
            <p className="text-xs text-muted-foreground">
              {receivedEmail.fromEmail}
            </p>
          )}
          <p className="text-xs text-muted-foreground">
            {format(
              isReceived ? receivedEmail.receivedAt : sentEmail.sentAt,
              "MMM d, yyyy 'at' h:mm a"
            )}
          </p>
        </div>
        {!isReceived && sentEmail.attachmentCount > 0 && (
          <span className="text-xs bg-muted px-2 py-1 rounded">
            {sentEmail.attachmentCount} attachment(s)
          </span>
        )}
      </div>
      <p className="text-sm font-medium mb-2">
        {isReceived ? receivedEmail.subject : sentEmail.subject}
      </p>
      <p className="text-sm whitespace-pre-wrap break-words">
        {isReceived ? receivedEmail.bodyPreview : sentEmail.bodyPreview}
      </p>
    </div>
  );
}
